import { createOverride } from '@ayocore/platform/client/extensions/createOverride';
import CreatePartnerForm from './components/Partners/forms/CreatePartnerForm';
import EditPartnerForm from './components/Partners/forms/EditPartnerForm';
import { CreateLeadForm } from './components/Leads/forms/CreateLeadForm';

/**
 * Центральный реестр переопределяемых компонентов CRM-модуля.
 *
 * Каждый клиентский модуль может заменить любой компонент через .set()
 * в своём bootstrap.ts — до первого рендера приложения.
 *
 * createOverride  — для компонентов без циклических зависимостей (формы)
 * createLazyOverride — для компонентов с циклическими зависимостями (списки, вьюхи)
 *                     Suspense встроен — разработчик просто вызывает .get() и рендерит.
 *
 * @example
 * // Переопределение в bootstrap.ts клиентского модуля:
 * import { CrmExtensions } from '@ayocore/erp/crm/client/extensions';
 * import { CreatePartnerFormGrasias } from './components/CreatePartnerFormGrasias';
 *
 * CrmExtensions.Partners.createForm.set(CreatePartnerFormGrasias);
 *
 * // Использование в компоненте:
 * const Form = CrmExtensions.Partners.createForm.get();
 * <Form onPartnerCreated={...} />
 */
export const CrmExtensions = {
  Partners: {
    /** Форма создания партнёра */
    createForm: createOverride(CreatePartnerForm),

    /** Форма редактирования партнёра */
    editForm: createOverride(EditPartnerForm),

    /** Список партнёров (lazy — разрывает циклическую зависимость) */
    // list: createLazyOverride(() => import('./components/Partners/PartnersList')),

    /** Страница просмотра партнёра (lazy — разрывает циклическую зависимость) */
    // view: createLazyOverride(() => import('./components/Partners/views/PartnerViewPage').then(m => ({ default: m.PartnerViewPage }))),
  },

  Leads: {
    /** Форма создания лида */
    createForm: createOverride(CreateLeadForm),
  },

  // Deals: {
  //   createForm: createOverride(CreateDealForm),
  //   view: createLazyOverride(() => import('./components/Deals/views/DealViewPage').then(m => ({ default: m.DealViewPage }))),
  // },
};
